import React, { useEffect, useState, Fragment } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import moment from 'moment';
import { capitalize, startCase, camelCase } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { hideLoading, showLoading } from '../../redux/loader/LoaderActions';
import { GET } from '../../services/rest.service';
import { showModal } from '../../redux/error/ErrorAction';
import { getPortName, weightFormat } from '../../helpers/utils';
import { accessGeneralOrCargoType, getJobStatus } from '../../helpers/utils';
import { showDocumentModal } from '../../redux/user/UserActions';

const JobDetailsModal = (props) => {
  const { jobId, isOpen, toggle } = props;
  const dispatch = useDispatch();

  const serviceData = useSelector((state) => state.enumData);
  const [jobDetails, setJobDetails] = useState({});
  const showDoc = (docc) => dispatch(showDocumentModal(docc));

  const getJobDetails = (id) => {
    dispatch(showLoading());
    GET(`/jobs/getDetails/${id}`)
      .then(({ data }) => {
        // console.log('data', data);
        setJobDetails(data.job);
        dispatch(hideLoading());
      })
      .catch((err) => {
        // console.log('err', err);
        dispatch(showModal(err.message));
        dispatch(hideLoading());
        props.history.goBack();
      });
  };

  useEffect(() => {
    if (jobId) {
      getJobDetails(jobId);
    }
  }, [jobId]);

  const getDetails = () => {
    return (
      <>
        {/* Vehicle Category Details */}
        {jobDetails.category === 1 && (
          <div
            className="card border-0 mb-4"
            style={{
              borderRadius: '16px',
              boxShadow: '0 8px 24px rgba(0,118,121,0.12)',
              overflow: 'hidden',
              background: '#ffffff',
            }}
          >
            <div
              className="card-header"
              style={{
                background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                borderBottom: '3px solid #01a8af',
                padding: '1.5rem 2rem',
              }}
            >
              <h4
                className="mb-0"
                style={{ color: '#ffffff', fontSize: '1.7rem', fontWeight: '700' }}
              >
                <i
                  className="fa fa-car"
                  style={{ marginRight: '8px', color: '#ffffff' }}
                ></i>
                Vehicle Details
              </h4>
            </div>
            <div className="card-body p-4" style={{ background: '#fafafa' }}>
              <div className="w-100">
                {/* Key Information Cards Integrated */}
                

                <div className="row g-4 mb-4">
                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100"
                      style={{
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(0,118,121,0.15)',
                        overflow: 'hidden',
                      }}
                    >
                      <div className="card-body p-4">
                        <div className="d-flex align-items-center mb-3">
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center me-3"
                            style={{
                              width: '50px',
                              height: '50px',
                              background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                            }}
                          >
                            <i
                              className="fa fa-list text-white"
                              style={{ fontSize: '1.5rem' }}
                            ></i>
                          </div>
                          <div>
                            <p
                              className="text-muted mb-1"
                              style={{
                                fontSize: '1.1rem',
                                fontWeight: '700',
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                              }}
                            >
                              Cargo Category
                            </p>
                            <h4 className="mb-0 fw-bold" style={{ color: '#007679', fontSize: '1.2rem' }}>
                              {serviceData?.job?.category?.[jobDetails.category] ? capitalize(serviceData.job.category[jobDetails.category]) : 'N/A'}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100"
                      style={{
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(1,168,175,0.15)',
                        overflow: 'hidden',
                      }}
                    >
                      <div className="card-body p-4">
                        <div className="d-flex align-items-center mb-3">
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center me-3"
                            style={{
                              width: '50px',
                              height: '50px',
                              background: 'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)',
                            }}
                          >
                            <i className="fa fa-truck text-white" style={{ fontSize: '1.5rem' }}></i>
                          </div>
                          <div>
                            <p
                              className="text-muted mb-1"
                              style={{
                                fontSize: '1.1rem',
                                fontWeight: '700',
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                              }}
                            >
                              Type of Vehicle
                            </p>
                            <h4 className="mb-0 fw-bold" style={{ color: '#01a8af', fontSize: '1.2rem' }}>
                              {serviceData?.job?.vehicle_type?.[jobDetails.type] ? capitalize(serviceData.job.vehicle_type[jobDetails.type]) : 'N/A'}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100"
                      style={{
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(29,174,178,0.15)',
                        overflow: 'hidden',
                      }}
                    >
                      <div className="card-body p-4">
                        <div className="d-flex align-items-center mb-3">
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center me-3"
                            style={{
                              width: '50px',
                              height: '50px',
                              background: 'linear-gradient(135deg, #1daeb2 0%, #29bec1 100%)',
                            }}
                          >
                            <i className="fa fa-cubes text-white" style={{ fontSize: '1.5rem' }}></i>
                          </div>
                          <div>
                            <p
                              className="text-muted mb-1"
                              style={{
                                fontSize: '1.1rem',
                                fontWeight: '700',
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                              }}
                            >
                              No of Containers
                            </p>
                            <h4 className="mb-0 fw-bold" style={{ color: '#1daeb2', fontSize: '1.2rem' }}>
                              {jobDetails?.containers?.length || jobDetails?.vehicles?.length || jobDetails?.no_of_containers || 0}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row g-4 mb-4">
                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100"
                      style={{
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(0,118,121,0.15)',
                        overflow: 'hidden',
                      }}
                    >
                      <div className="card-body p-4">
                        <div className="d-flex align-items-center mb-3">
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center me-3"
                            style={{
                              width: '50px',
                              height: '50px',
                              background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                            }}
                          >
                            <i
                              className="fa fa-info-circle text-white"
                              style={{ fontSize: '1.5rem' }}
                            ></i>
                          </div>
                          <div>
                            <p
                              className="text-muted mb-1"
                              style={{
                                fontSize: '1.1rem',
                                fontWeight: '700',
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                              }}
                            >
                              Status
                            </p>
                            <h4 className="mb-0 fw-bold" style={{ color: '#007679', fontSize: '1.2rem' }}>
                              {getJobStatus(jobDetails, serviceData)}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100"
                      style={{
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(1,168,175,0.15)',
                        overflow: 'hidden',
                      }}
                    >
                      <div className="card-body p-4">
                        <div className="d-flex align-items-center mb-3">
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center me-3"
                            style={{
                              width: '50px',
                              height: '50px',
                              background: 'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)',
                            }}
                          >
                            <i className="fa fa-calendar text-white" style={{ fontSize: '1.5rem' }}></i>
                          </div>
                          <div>
                            <p
                              className="text-muted mb-1"
                              style={{
                                fontSize: '1.1rem',
                                fontWeight: '700',
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                              }}
                            >
                              Arrival
                            </p>
                            <h4 className="mb-0 fw-bold" style={{ color: '#01a8af', fontSize: '1.2rem' }}>
                              {moment(jobDetails.date_of_arrival).format('DD MMM YYYY') || 'N/A'}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100"
                      style={{
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(29,174,178,0.15)',
                        overflow: 'hidden',
                      }}
                    >
                      <div className="card-body p-4">
                        <div className="d-flex align-items-center mb-3">
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center me-3"
                            style={{
                              width: '50px',
                              height: '50px',
                              background: 'linear-gradient(135deg, #1daeb2 0%, #29bec1 100%)',
                            }}
                          >
                            <i className="fa fa-ship text-white" style={{ fontSize: '1.5rem' }}></i>
                          </div>
                          <div>
                            <p
                              className="text-muted mb-1"
                              style={{
                                fontSize: '1.1rem',
                                fontWeight: '700',
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                              }}
                            >
                              Port
                            </p>
                            <h4 className="mb-0 fw-bold" style={{ color: '#1daeb2', fontSize: '1.2rem' }}>
                              {jobDetails?.clearing_discharge_port
                                ? getPortName(jobDetails.clearing_discharge_port, serviceData)
                                : 'N/A'}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {jobDetails.containers && jobDetails.containers.length > 0 && (
                <div className="mt-4">
                  {jobDetails.containers.map((x, index) => (
                    <div key={index} className={index > 0 ? 'mt-5' : ''}>
                      <div className="p-3 mb-4 rounded-4" style={{ background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)', color: 'white', boxShadow: '0 4px 12px rgba(0,118,121,0.2)' }}>
                        <h4
                          className="fw-bold mb-0"
                          style={{ color: '#ffffff', fontSize: '1.5rem' }}
                        >
                          <i className="fa fa-cube me-2"></i>Container {index + 1}
                        </h4>
                      </div>

                      <div className="row g-4 mb-4">
                        <div className="col-md-4">
                          <div className="p-4 rounded-4 h-100 text-center" style={{ background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)', color: 'white' }}>
                            <p className="mb-2" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                              <i className="fa fa-arrows-alt me-2"></i>Size of Container
                            </p>
                            <h3 className="mb-0 fw-bold" style={{ fontSize: '1.5rem', color: 'white' }}>
                              {x.size_of_container || x.size || x.vehicles?.[0]?.size_of_container || jobDetails.size || 'N/A'}
                            </h3>
                            <p className="mb-0 mt-1" style={{ fontSize: '1rem', opacity: 0.9 }}>
                              Type: {x.container_type || x.vehicles?.[0]?.container_type || 'N/A'}
                            </p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="p-4 rounded-4 h-100 text-center" style={{ background: 'linear-gradient(135deg, #e8f5f5 0%, #d4efef 100%)', borderLeft: '6px solid #1daeb2' }}>
                            <p className="mb-2 text-center" style={{ fontSize: '1.4rem', fontWeight: '700', color: '#1daeb2', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                              <i className="fa fa-car me-2"></i>Number of Vehicles
                            </p>
                            <h4 className="mb-0 fw-bold text-center" style={{ color: '#1daeb2', fontSize: '1.5rem' }}>
                              {x.vehicles?.length || 0}
                            </h4>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="p-4 rounded-4 h-100 text-center" style={{ background: 'linear-gradient(135deg, #f0f9f9 0%, #e0f2f2 100%)', borderLeft: '6px solid #01a8af' }}>
                            <p className="mb-2 text-center" style={{ fontSize: '1.4rem', fontWeight: '700', color: '#01a8af', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                              <i className="fa fa-list me-2"></i>Description of added items
                            </p>
                            <h3 className="mb-0 fw-bold text-center" style={{ fontSize: '1.5rem', color: '#004d4d' }}>
                              {x.load_description || x.item_name || 'N/A'}
                            </h3>
                          </div>
                        </div>
                      </div>

                      {x.vehicles && x.vehicles.length > 0 && (
                        <div className="row g-4">
                          {x.vehicles.map((v, i) => (
                            <div className="col-lg-6 col-sm-12" key={i}>
                              <div
                                className="card border-0 h-100"
                                style={{
                                  background: '#ffffff',
                                  borderRadius: '20px',
                                  boxShadow: '0 4px 15px rgba(1,168,175,0.15)',
                                  overflow: 'hidden',
                                }}
                              >
                                <div
                                  className="card-header"
                                  style={{
                                    background:
                                      'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)',
                                    padding: '1.25rem 1.5rem',
                                    border: 'none',
                                  }}
                                >
                                  <div className="d-flex justify-content-between align-items-center">
                                    <h5
                                      className="mb-0 fw-bold text-white"
                                      style={{ fontSize: '1.3rem' }}
                                    >
                                      {jobDetails.type === 1
                                        ? 'Vehicle Information'
                                        : `Vehicle ${i + 1}`}
                                    </h5>
                                    <span
                                      className="badge bg-white"
                                      style={{
                                        color: '#01a8af',
                                        fontSize: '1rem',
                                        fontWeight: '700',
                                        padding: '0.5rem 1rem',
                                      }}
                                    >
                                      Vehicle #{i + 1}
                                    </span>
                                  </div>
                                </div>
                                <div className="card-body p-4">
                                  <div className="row g-3">
                                    <div className="col-6">
                                      <div
                                        className="p-3 rounded-4 h-100"
                                        style={{
                                          background: '#f8f9fa',
                                          border: '1px solid #eee',
                                        }}
                                      >
                                        <p
                                          className="mb-1"
                                          style={{
                                            fontSize: '1.4rem',
                                            fontWeight: '700',
                                            color: '#01a8af',
                                            textTransform: 'uppercase',
                                          }}
                                        >
                                          Brand
                                        </p>
                                        <p
                                          className="mb-0 fw-bold"
                                          style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                                        >
                                          {v.brand}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="col-6">
                                      <div
                                        className="p-3 rounded-4 h-100"
                                        style={{
                                          background: '#f8f9fa',
                                          border: '1px solid #eee',
                                        }}
                                      >
                                        <p
                                          className="mb-1"
                                          style={{
                                            fontSize: '1.4rem',
                                            fontWeight: '700',
                                            color: '#01a8af',
                                            textTransform: 'uppercase',
                                          }}
                                        >
                                          Year
                                        </p>
                                        <p
                                          className="mb-0 fw-bold"
                                          style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                                        >
                                          {v.year}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="col-6">
                                      <div
                                        className="p-3 rounded-4 h-100"
                                        style={{
                                          background: '#f8f9fa',
                                          border: '1px solid #eee',
                                        }}
                                      >
                                        <p
                                          className="mb-1"
                                          style={{
                                            fontSize: '1.4rem',
                                            fontWeight: '700',
                                            color: '#01a8af',
                                            textTransform: 'uppercase',
                                          }}
                                        >
                                          Model
                                        </p>
                                        <p
                                          className="mb-0 fw-bold"
                                          style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                                        >
                                          {v.model}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="col-6">
                                      <div
                                        className="p-3 rounded-4 h-100"
                                        style={{
                                          background: '#f8f9fa',
                                          border: '1px solid #eee',
                                        }}
                                      >
                                        <p
                                          className="mb-1"
                                          style={{
                                            fontSize: '1.4rem',
                                            fontWeight: '700',
                                            color: '#01a8af',
                                            textTransform: 'uppercase',
                                          }}
                                        >
                                          Condition
                                        </p>
                                        <p
                                          className="mb-0 fw-bold"
                                          style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                                        >
                                          {capitalize(
                                            serviceData.job.vehicle_state[v.vehicle_state],
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="col-12">
                                      <div
                                        className="p-3 rounded-4"
                                        style={{
                                          background: '#f8f9fa',
                                          border: '1px solid #eee',
                                        }}
                                      >
                                        <p
                                          className="mb-1"
                                          style={{
                                            fontSize: '1.4rem',
                                            fontWeight: '700',
                                            color: '#01a8af',
                                            textTransform: 'uppercase',
                                          }}
                                        >
                                          VREG Number
                                        </p>
                                        <p
                                          className="mb-0 fw-bold"
                                          style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                                        >
                                          {v.vreg_no || 'N/A'}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {/* Cargo Category Details */}
        {jobDetails.category === 2 && (
          <div
            className="card border-0 mb-4"
            style={{
              borderRadius: '16px',
              boxShadow: '0 8px 24px rgba(0,118,121,0.12)',
              overflow: 'hidden',
              background: '#ffffff',
            }}
          >
            <div
              className="card-header"
              style={{
                background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                borderBottom: '3px solid #01a8af',
                padding: '1.5rem 2rem',
              }}
            >
              <h4
                className="mb-0"
                style={{ color: '#ffffff', fontSize: '1.7rem', fontWeight: '700' }}
              >
                <i
                  className="fa fa-cubes"
                  style={{ marginRight: '8px', color: '#ffffff' }}
                ></i>
                Cargo Details
              </h4>
            </div>
            <div className="card-body p-4" style={{ background: '#fafafa' }}>
              <div className="w-100">
                {/* Key Information Cards Integrated */}
                <div className="row g-4 mb-4">
                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100"
                      style={{
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(0,118,121,0.15)',
                        overflow: 'hidden',
                      }}
                    >
                      <div className="card-body p-4">
                        <div className="d-flex align-items-center mb-3">
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center me-3"
                            style={{
                              width: '50px',
                              height: '50px',
                              background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                            }}
                          >
                            <i
                              className="fa fa-list text-white"
                              style={{ fontSize: '1.5rem' }}
                            ></i>
                          </div>
                          <div>
                            <p
                              className="text-muted mb-1"
                              style={{
                                fontSize: '1.1rem',
                                fontWeight: '700',
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                              }}
                            >
                              Cargo Category
                            </p>
                            <h4 className="mb-0 fw-bold" style={{ color: '#007679', fontSize: '1.2rem' }}>
                              {serviceData?.job?.category?.[jobDetails.category] ? capitalize(serviceData.job.category[jobDetails.category]) : 'N/A'}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100"
                      style={{
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(1,168,175,0.15)',
                        overflow: 'hidden',
                      }}
                    >
                      <div className="card-body p-4">
                        <div className="d-flex align-items-center mb-3">
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center me-3"
                            style={{
                              width: '50px',
                              height: '50px',
                              background: 'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)',
                            }}
                          >
                            <i className="fa fa-box-open text-white" style={{ fontSize: '1.5rem' }}></i>
                          </div>
                          <div>
                            <p
                              className="text-muted mb-1"
                              style={{
                                fontSize: '1.1rem',
                                fontWeight: '700',
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                              }}
                            >
                              Type of Cargo
                            </p>
                            <h4 className="mb-0 fw-bold" style={{ color: '#01a8af', fontSize: '1.2rem' }}>
                              {accessGeneralOrCargoType(jobDetails, serviceData)}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100"
                      style={{
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(29,174,178,0.15)',
                        overflow: 'hidden',
                      }}
                    >
                      <div className="card-body p-4">
                        <div className="d-flex align-items-center mb-3">
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center me-3"
                            style={{
                              width: '50px',
                              height: '50px',
                              background: 'linear-gradient(135deg, #1daeb2 0%, #29bec1 100%)',
                            }}
                          >
                            <i className="fa fa-cubes text-white" style={{ fontSize: '1.5rem' }}></i>
                          </div>
                          <div>
                            <p
                              className="text-muted mb-1"
                              style={{
                                fontSize: '1.1rem',
                                fontWeight: '700',
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                              }}
                            >
                              No of Containers
                            </p>
                            <h4 className="mb-0 fw-bold" style={{ color: '#1daeb2', fontSize: '1.2rem' }}>
                              {jobDetails?.no_of_containers || jobDetails?.containers?.length || 0}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row g-4 mb-4">
                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100"
                      style={{
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(0,118,121,0.15)',
                        overflow: 'hidden',
                      }}
                    >
                      <div className="card-body p-4">
                        <div className="d-flex align-items-center mb-3">
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center me-3"
                            style={{
                              width: '50px',
                              height: '50px',
                              background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                            }}
                          >
                            <i
                              className="fa fa-info-circle text-white"
                              style={{ fontSize: '1.5rem' }}
                            ></i>
                          </div>
                          <div>
                            <p
                              className="text-muted mb-1"
                              style={{
                                fontSize: '1.1rem',
                                fontWeight: '700',
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                              }}
                            >
                              Status
                            </p>
                            <h4 className="mb-0 fw-bold" style={{ color: '#007679', fontSize: '1.2rem' }}>
                              {getJobStatus(jobDetails, serviceData)}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100"
                      style={{
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(1,168,175,0.15)',
                        overflow: 'hidden',
                      }}
                    >
                      <div className="card-body p-4">
                        <div className="d-flex align-items-center mb-3">
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center me-3"
                            style={{
                              width: '50px',
                              height: '50px',
                              background: 'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)',
                            }}
                          >
                            <i className="fa fa-calendar text-white" style={{ fontSize: '1.5rem' }}></i>
                          </div>
                          <div>
                            <p
                              className="text-muted mb-1"
                              style={{
                                fontSize: '1.1rem',
                                fontWeight: '700',
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                              }}
                            >
                              Arrival
                            </p>
                            <h4 className="mb-0 fw-bold" style={{ color: '#01a8af', fontSize: '1.2rem' }}>
                              {moment(jobDetails.date_of_arrival).format('DD MMM YYYY') || 'N/A'}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100"
                      style={{
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(29,174,178,0.15)',
                        overflow: 'hidden',
                      }}
                    >
                      <div className="card-body p-4">
                        <div className="d-flex align-items-center mb-3">
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center me-3"
                            style={{
                              width: '50px',
                              height: '50px',
                              background: 'linear-gradient(135deg, #1daeb2 0%, #29bec1 100%)',
                            }}
                          >
                            <i className="fa fa-ship text-white" style={{ fontSize: '1.5rem' }}></i>
                          </div>
                          <div>
                            <p
                              className="text-muted mb-1"
                              style={{
                                fontSize: '1.1rem',
                                fontWeight: '700',
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                              }}
                            >
                              Port
                            </p>
                            <h4 className="mb-0 fw-bold" style={{ color: '#1daeb2', fontSize: '1.2rem' }}>
                              {jobDetails?.clearing_discharge_port
                                ? getPortName(jobDetails.clearing_discharge_port, serviceData)
                                : 'N/A'}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {jobDetails.containers && jobDetails.containers.length > 0 && (
                <div className="mt-4">
                  {jobDetails.containers.map((x, index) => (
                    <div key={index} className={index > 0 ? 'mt-5' : ''}>
                      <div className="p-3 mb-4 rounded-4" style={{ background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)', color: 'white', boxShadow: '0 4px 12px rgba(0,118,121,0.2)' }}>
                        <h4
                          className="fw-bold mb-0"
                          style={{ color: '#ffffff', fontSize: '1.5rem' }}
                        >
                          <i className="fa fa-cube me-2"></i>Container {index + 1}
                        </h4>
                      </div>

                      <div className="row g-4 mb-4">
                        <div className="col-md-6">
                          <div className="p-4 rounded-4 h-100 text-center" style={{ background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)', color: 'white' }}>
                            <p className="mb-2" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                              <i className="fa fa-arrows-alt me-2"></i>Size of Container
                            </p>
                            <h3 className="mb-0 fw-bold" style={{ fontSize: '1.5rem', color: 'white' }}>
                              {x.size_of_container || x.size || x.vehicles?.[0]?.size_of_container || jobDetails.size || 'N/A'}
                            </h3>
                            <p className="mb-0 mt-1" style={{ fontSize: '1rem', opacity: 0.9 }}>
                              Type: {x.container_type || x.vehicles?.[0]?.container_type || 'N/A'}
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="p-4 rounded-4 h-100 text-center" style={{ background: 'linear-gradient(135deg, #e8f5f5 0%, #d4efef 100%)', borderLeft: '6px solid #1daeb2' }}>
                            <p className="mb-2" style={{ fontSize: '1.4rem', fontWeight: '700', color: '#1daeb2', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                              <i className="fa fa-cube me-2"></i>Item Title
                            </p>
                            <h4 className="mb-0 fw-bold" style={{ color: '#1daeb2', fontSize: '1.5rem' }}>
                              {x.item_name || x.item_title || x.load_description || 'N/A'}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {/* Tonnage Category Details */}
        {jobDetails.category === 3 && (
          <div
            className="card border-0 mb-4"
            style={{
              borderRadius: '16px',
              boxShadow: '0 8px 24px rgba(0,118,121,0.12)',
              overflow: 'hidden',
              background: '#ffffff',
            }}
          >
            <div
              className="card-header"
              style={{
                background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                borderBottom: '3px solid #01a8af',
                padding: '1.5rem 2rem',
              }}
            >
              <h4
                className="mb-0"
                style={{ color: '#ffffff', fontSize: '1.7rem', fontWeight: '700' }}
              >
                <i
                  className="fa fa-balance-scale"
                  style={{ marginRight: '8px', color: '#ffffff' }}
                ></i>
                Cargo Details
              </h4>
            </div>
            <div className="card-body p-4" style={{ background: '#fafafa' }}>
              <div className="row g-4 mb-4">
                <div className="col-md-4">
                  <div
                    className="card border-0 h-100"
                    style={{
                      borderRadius: '16px',
                      boxShadow: '0 4px 20px rgba(0,118,121,0.15)',
                      overflow: 'hidden',
                    }}
                  >
                    <div className="card-body p-4">
                      <div className="d-flex align-items-center mb-3">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center me-3"
                          style={{
                            width: '50px',
                            height: '50px',
                            background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                          }}
                        >
                          <i
                            className="fa fa-list text-white"
                            style={{ fontSize: '1.5rem' }}
                          ></i>
                        </div>
                        <div>
                          <p
                            className="text-muted mb-1"
                            style={{
                              fontSize: '1.1rem',
                              fontWeight: '700',
                              textTransform: 'uppercase',
                              letterSpacing: '1px',
                            }}
                          >
                            Cargo Category
                          </p>
                          <h4 className="mb-0 fw-bold" style={{ color: '#007679', fontSize: '1.2rem' }}>
                            {serviceData?.job?.category?.[jobDetails.category] ? capitalize(serviceData.job.category[jobDetails.category]) : 'N/A'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {accessGeneralOrCargoType(jobDetails, serviceData) &&
                  accessGeneralOrCargoType(jobDetails, serviceData) !== 'N/A' && (
                    <div className="col-md-4">
                      <div
                        className="card border-0 h-100"
                        style={{
                          borderRadius: '16px',
                          boxShadow: '0 4px 20px rgba(1,168,175,0.15)',
                          overflow: 'hidden',
                        }}
                      >
                        <div className="card-body p-4">
                          <div className="d-flex align-items-center mb-3">
                            <div
                              className="rounded-circle d-flex align-items-center justify-content-center me-3"
                              style={{
                                width: '50px',
                                height: '50px',
                                background: 'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)',
                              }}
                            >
                              <i className="fa fa-box-open text-white" style={{ fontSize: '1.5rem' }}></i>
                            </div>
                            <div>
                              <p
                                className="text-muted mb-1"
                                style={{
                                  fontSize: '1.1rem',
                                  fontWeight: '700',
                                  textTransform: 'uppercase',
                                  letterSpacing: '1px',
                                }}
                              >
                                Type of Cargo
                              </p>
                              <h4 className="mb-0 fw-bold" style={{ color: '#01a8af', fontSize: '1.2rem' }}>
                                {accessGeneralOrCargoType(jobDetails, serviceData)}
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                {jobDetails.tonnage && jobDetails.tonnage !== 'N/A' && (
                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100"
                      style={{
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(29,174,178,0.15)',
                        overflow: 'hidden',
                      }}
                    >
                      <div className="card-body p-4">
                        <div className="d-flex align-items-center mb-3">
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center me-3"
                            style={{
                              width: '50px',
                              height: '50px',
                              background: 'linear-gradient(135deg, #1daeb2 0%, #29bec1 100%)',
                            }}
                          >
                            <i className="fa fa-weight-hanging text-white" style={{ fontSize: '1.5rem' }}></i>
                          </div>
                          <div>
                            <p
                              className="text-muted mb-1"
                              style={{
                                fontSize: '1.1rem',
                                fontWeight: '700',
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                              }}
                            >
                              Tonnage
                            </p>
                            <h4 className="mb-0 fw-bold" style={{ color: '#1daeb2', fontSize: '1.2rem' }}>
                              {jobDetails.tonnage}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Key Information Cards Integrated */}
              <div className="row g-4 mb-4">
                <div className="col-md-4">
                  <div
                    className="card border-0 h-100"
                    style={{
                      borderRadius: '16px',
                      boxShadow: '0 4px 20px rgba(0,118,121,0.15)',
                      overflow: 'hidden',
                    }}
                  >
                    <div className="card-body p-4">
                      <div className="d-flex align-items-center mb-3">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center me-3"
                          style={{
                            width: '50px',
                            height: '50px',
                            background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                          }}
                        >
                          <i
                            className="fa fa-info-circle text-white"
                            style={{ fontSize: '1.5rem' }}
                          ></i>
                        </div>
                        <div>
                          <p
                            className="text-muted mb-1"
                            style={{
                              fontSize: '1.1rem',
                              fontWeight: '700',
                              textTransform: 'uppercase',
                              letterSpacing: '1px',
                            }}
                          >
                            Status
                          </p>
                          <h4 className="mb-0 fw-bold" style={{ color: '#007679', fontSize: '1.2rem' }}>
                            {getJobStatus(jobDetails, serviceData)}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div
                    className="card border-0 h-100"
                    style={{
                      borderRadius: '16px',
                      boxShadow: '0 4px 20px rgba(1,168,175,0.15)',
                      overflow: 'hidden',
                    }}
                  >
                    <div className="card-body p-4">
                      <div className="d-flex align-items-center mb-3">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center me-3"
                          style={{
                            width: '50px',
                            height: '50px',
                            background: 'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)',
                          }}
                        >
                          <i className="fa fa-calendar text-white" style={{ fontSize: '1.5rem' }}></i>
                        </div>
                        <div>
                          <p
                            className="text-muted mb-1"
                            style={{
                              fontSize: '1.1rem',
                              fontWeight: '700',
                              textTransform: 'uppercase',
                              letterSpacing: '1px',
                            }}
                          >
                            Arrival
                          </p>
                          <h4 className="mb-0 fw-bold" style={{ color: '#01a8af', fontSize: '1.2rem' }}>
                            {moment(jobDetails.date_of_arrival).format('DD MMM YYYY') || 'N/A'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div
                    className="card border-0 h-100"
                    style={{
                      borderRadius: '16px',
                      boxShadow: '0 4px 20px rgba(29,174,178,0.15)',
                      overflow: 'hidden',
                    }}
                  >
                    <div className="card-body p-4">
                      <div className="d-flex align-items-center mb-3">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center me-3"
                          style={{
                            width: '50px',
                            height: '50px',
                            background: 'linear-gradient(135deg, #1daeb2 0%, #29bec1 100%)',
                          }}
                        >
                          <i className="fa fa-ship text-white" style={{ fontSize: '1.5rem' }}></i>
                        </div>
                        <div>
                          <p
                            className="text-muted mb-1"
                            style={{
                              fontSize: '1.1rem',
                              fontWeight: '700',
                              textTransform: 'uppercase',
                              letterSpacing: '1px',
                            }}
                          >
                            Port
                          </p>
                          <h4 className="mb-0 fw-bold" style={{ color: '#1daeb2', fontSize: '1.2rem' }}>
                            {jobDetails?.clearing_discharge_port
                              ? getPortName(jobDetails.clearing_discharge_port, serviceData)
                              : 'N/A'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Transport Job Details (Forwarding) */}
        {jobDetails.has_forwarding === 1 && (
          <div
            className="card border-0 mb-4"
            style={{
              borderRadius: '16px',
              boxShadow: '0 8px 24px rgba(0,118,121,0.12)',
              overflow: 'hidden',
              background: '#ffffff',
            }}
          >
            <div
              className="card-header"
              style={{
                background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                borderBottom: '3px solid #007679',
                padding: '1.5rem 2rem',
              }}
            >
              <h4
                className="mb-0"
                style={{ color: '#ffffff', fontSize: '1.4rem', fontWeight: '700' }}
              >
                <i
                  className="fa fa-truck"
                  style={{ marginRight: '8px', color: '#ffffff' }}
                ></i>
                Transport Job Details
              </h4>
            </div>
            <div className="card-body p-4" style={{ background: '#fafafa' }}>
              {jobDetails?.forwarding_agent?.first_name && (
                <div
                  className="mb-4 p-4 rounded-4"
                  style={{
                    background: 'linear-gradient(135deg, #e8f5f5 0%, #d4efef 100%)',
                    borderLeft: '6px solid #007679',
                  }}
                >
                  <p
                    className="mb-2"
                    style={{
                      fontSize: '1.4rem',
                      fontWeight: '700',
                      color: '#007679',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                    }}
                  >
                    <i className="fa fa-user me-2"></i>Transporter Name
                  </p>
                  <h3
                    className="mb-0 fw-bold"
                    style={{ color: '#004d4d', fontSize: '1.5rem' }}
                  >
                    {jobDetails.forwarding_agent.first_name}{' '}
                    {jobDetails.forwarding_agent.last_name}
                  </h3>
                </div>
              )}
              <div className="row g-4">
                {serviceData?.port_locations?.[jobDetails?.port_of_discharge] && (
                  <div className="col-md-6">
                    <div
                      className="p-4 rounded-4"
                      style={{ background: '#f8f9fa', border: '2px solid #e0e0e0' }}
                    >
                      <p
                        className="mb-2"
                        style={{
                          fontSize: '1.2rem',
                          fontWeight: '700',
                          color: '#6c757d',
                          textTransform: 'uppercase',
                        }}
                      >
                        <i className="fa fa-ship me-2"></i>Port of Discharge
                      </p>
                      <p
                        className="mb-0 fw-bold"
                        style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                      >
                        {capitalize(serviceData.port_locations[jobDetails.port_of_discharge]) || 'N/A'}
                      </p>
                    </div>
                  </div>
                )}
                {/* Terminal and Shipping Line are what an agent prices the work
                    off, so they sit alongside the port rather than further down
                    with the documents. Names come from the eager-loaded
                    relations, not the reference lists, so a retired terminal
                    still reads correctly on an older job. */}
                {jobDetails?.terminal_display && (
                  <div className="col-md-6">
                    <div
                      className="p-4 rounded-4"
                      style={{ background: '#f8f9fa', border: '2px solid #e0e0e0' }}
                    >
                      <p
                        className="mb-2"
                        style={{
                          fontSize: '1.2rem',
                          fontWeight: '700',
                          color: '#6c757d',
                          textTransform: 'uppercase',
                        }}
                      >
                        <i className="fa fa-building me-2"></i>Terminal
                      </p>
                      <p className="mb-0 fw-bold" style={{ fontSize: '1.5rem', color: '#2c3e50' }}>
                        {jobDetails.terminal_display}
                      </p>
                    </div>
                  </div>
                )}
                {jobDetails?.shipping_line_display && (
                  <div className="col-md-6">
                    <div
                      className="p-4 rounded-4"
                      style={{ background: '#f8f9fa', border: '2px solid #e0e0e0' }}
                    >
                      <p
                        className="mb-2"
                        style={{
                          fontSize: '1.2rem',
                          fontWeight: '700',
                          color: '#6c757d',
                          textTransform: 'uppercase',
                        }}
                      >
                        <i className="fa fa-anchor me-2"></i>Shipping Line
                      </p>
                      <p className="mb-0 fw-bold" style={{ fontSize: '1.5rem', color: '#2c3e50' }}>
                        {jobDetails.shipping_line_display}
                      </p>
                    </div>
                  </div>
                )}
                {jobDetails?.destination && (
                  <div className="col-md-6">
                    <div
                      className="p-4 rounded-4"
                      style={{ background: '#f8f9fa', border: '2px solid #e0e0e0' }}
                    >
                      <p
                        className="mb-2"
                        style={{
                          fontSize: '1.2rem',
                          fontWeight: '700',
                          color: '#6c757d',
                          textTransform: 'uppercase',
                        }}
                      >
                        <i className="fa fa-map-marker me-2"></i>Destination
                      </p>
                      <p
                        className="mb-0 fw-bold"
                        style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                      >
                        {jobDetails.destination || 'N/A'}
                      </p>
                    </div>
                  </div>
                )}
                <div className="col-md-6">
                  <div
                    className="p-4 rounded-4"
                    style={{ background: '#f8f9fa', border: '2px solid #e0e0e0' }}
                  >
                    <p
                      className="mb-2"
                      style={{
                        fontSize: '1.4rem',
                        fontWeight: '700',
                        color: '#6c757d',
                        textTransform: 'uppercase',
                      }}
                    >
                      <i className="fa fa-map me-2"></i>State
                    </p>
                    <p
                      className="mb-0 fw-bold"
                      style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                    >
                      {serviceData.states.find(
                        (s) => s.uuid === jobDetails.destination_state,
                      )?.state || 'N/A'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Unbundled Jobs */}
        {jobDetails.children_packages && jobDetails.children_packages.length > 0 && (
          <div
            className="card border-0 mb-4"
            style={{
              borderRadius: '16px',
              boxShadow: '0 8px 24px rgba(0,118,121,0.12)',
              overflow: 'hidden',
              background: '#ffffff',
            }}
          >
            <div
              className="card-header"
              style={{
                background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                borderBottom: '3px solid #1daeb2',
                padding: '1.5rem 2rem',
              }}
            >
              <h4
                className="mb-0"
                style={{ color: '#ffffff', fontSize: '1.4rem', fontWeight: '700' }}
              >
                <i
                  className="fa fa-sitemap"
                  style={{ marginRight: '8px', color: '#ffffff' }}
                ></i>
                Unbundled Jobs
              </h4>
            </div>
            <div className="card-body p-4" style={{ background: '#fafafa' }}>
              {jobDetails.children_packages.map((x, index) => (
                <div
                  key={index}
                  className={`mb-4 ${
                    index < jobDetails.children_packages.length - 1 ? 'pb-4' : ''
                  }`}
                  style={{
                    borderBottom:
                      index < jobDetails.children_packages.length - 1
                        ? '2px solid #e0e0e0'
                        : 'none',
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5
                      className="mb-0 fw-bold"
                      style={{ color: '#007679', fontSize: '1.5rem' }}
                    >
                      <i className="fa fa-cube me-2"></i>Job {index + 1}: {x.job_id}
                    </h5>
                  </div>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div
                        className="p-4 rounded-4"
                        style={{ background: '#f8f9fa', border: '2px solid #e0e0e0' }}
                      >
                        <p
                          className="mb-1"
                          style={{
                            fontSize: '1.4rem',
                            fontWeight: '700',
                            color: '#6c757d',
                            textTransform: 'uppercase',
                          }}
                        >
                          Size
                        </p>
                        <p
                          className="mb-0 fw-bold"
                          style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                        >
                          {capitalize(serviceData.truck.size[x.size])}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div
                        className="p-4 rounded-4"
                        style={{ background: '#f8f9fa', border: '2px solid #e0e0e0' }}
                      >
                        <p
                          className="mb-1"
                          style={{
                            fontSize: '1.4rem',
                            fontWeight: '700',
                            color: '#6c757d',
                            textTransform: 'uppercase',
                          }}
                        >
                          Weight
                        </p>
                        <p
                          className="mb-0 fw-bold"
                          style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                        >
                          {weightFormat(x.weight)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </>
    );
  };
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      container="clearing-agent-page"
      className="modal-xl"
      centered
    >
      <div
        className="modal-header"
        style={{
          background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
          borderBottom: 'none',
          padding: '2rem 2rem 1.5rem',
          color: 'white',
        }}
      >
        <div className="w-100 text-center">
          <div className="d-flex justify-content-between align-items-start mb-4">
            <div className="w-100 text-center">
              <h2
                className="mb-3"
                style={{ fontWeight: '800', fontSize: '2.5rem', letterSpacing: '-0.5px' }}
              >
                <i className="fa fa-briefcase me-3"></i>
                Job Details
              </h2>
              <p
                className="mb-0"
                style={{ fontSize: '1.2rem', opacity: '0.95', fontWeight: '700' }}
              >
                {jobDetails.job_id &&
                  `Job ID: ${jobDetails.job_id}-${jobDetails.is_forwarding_only ? 'T' : 'C'}`}
              </p>
            </div>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={toggle}
              style={{ fontSize: '1.8rem', position: 'absolute', right: '2rem', top: '2rem' }}
            ></button>
          </div>

          <div className="d-flex flex-wrap gap-3 justify-content-center">
            {jobDetails.job_type_tags &&
              jobDetails.job_type_tags.map((y, i) => (
                <span
                  className="badge px-5 py-3"
                  style={{
                    backgroundColor: 'rgba(255,255,255,0.25)',
                    backdropFilter: 'blur(10px)',
                    fontSize: '1.2rem',
                    fontWeight: '700',
                    border: '2px solid rgba(255,255,255,0.5)',
                    letterSpacing: '0.5px',
                  }}
                  key={i}
                >
                  {capitalize(y === 'forwarding' ? 'Transport' : y)} Job
                </span>
              ))}
            <span
              className="badge px-5 py-3"
              style={{
                backgroundColor: 'rgba(255,255,255,0.95)',
                color: '#007679',
                fontSize: '1.2rem',
                fontWeight: '700',
                letterSpacing: '0.5px',
              }}
            >
              {capitalize(serviceData.job.category[jobDetails.category]) || 'N/A'}
            </span>
          </div>
        </div>
      </div>

      <ModalBody style={{ background: '#f8f9fa', padding: '2rem' }}>
        <div className="job-details-container" style={{ maxHeight: '70vh', overflowY: 'auto' }}>


          {(jobDetails?.clearing_agent?.first_name ||
            jobDetails?.clearing_agent?.last_name ||
            jobDetails?.port_of_discharge) && (
            <div
              className="card border-0 mb-4"
              style={{
                borderRadius: '16px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                overflow: 'hidden',
              }}
            >
              <div
                className="card-header"
                style={{
                  background: '#ffffff',
                  borderBottom: '3px solid #007679',
                  padding: '1.5rem 2rem',
                }}
              >
                <h4 className="mb-0 fw-bold" style={{ color: '#007679', fontSize: '1.4rem' }}>
                  <i className="fa fa-user-circle me-2"></i>
                  Additional Information
                </h4>
              </div>
              <div className="card-body p-4">
                <div className="row g-4">
                  {(jobDetails?.clearing_agent?.first_name ||
                    jobDetails?.clearing_agent?.last_name) && (
                    <div className="col-md-6">
                      <div
                        className="p-4 rounded-3"
                        style={{ background: '#e8f5f5', borderLeft: '5px solid #007679' }}
                      >
                        <p
                          className="mb-2"
                          style={{
                            fontSize: '1.2rem',
                            fontWeight: '700',
                            color: '#007679',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                          }}
                        >
                          <i className="fa fa-user me-2"></i>Clearing Agent
                        </p>
                        <p
                          className="mb-0 fw-bold"
                          style={{ fontSize: '1.25rem', color: '#004d4d' }}
                        >
                          {jobDetails?.clearing_agent?.first_name
                            ? `${jobDetails.clearing_agent.first_name} ${jobDetails?.clearing_agent
                                ?.last_name || ''}`
                            : jobDetails?.clearing_agent?.last_name || ''}
                        </p>
                      </div>
                    </div>
                  )}
                  {jobDetails?.port_of_discharge && (
                    <div className="col-md-6">
                      <div
                        className="p-4 rounded-3"
                        style={{ background: '#e8f5f5', borderLeft: '5px solid #01a8af' }}
                      >
                        <p
                          className="mb-2"
                          style={{
                            fontSize: '1.2rem',
                            fontWeight: '700',
                            color: '#01a8af',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                          }}
                        >
                          <i className="fa fa-map-marker me-2"></i>Pick-up Location
                        </p>
                        <p
                          className="mb-0 fw-bold"
                          style={{ fontSize: '1.25rem', color: '#004d4d' }}
                        >
                          {getPortName(jobDetails.port_of_discharge, serviceData)}
                        </p>
                      </div>
                    </div>
                  )}
                  {jobDetails.single_item_title && jobDetails.single_item_title !== 'N/A' && (
                    <div className="col-md-6">
                      <div
                        className="p-4 rounded-3"
                        style={{ background: '#e8f5f5', borderLeft: '5px solid #1daeb2' }}
                      >
                        <p
                          className="mb-2"
                          style={{
                            fontSize: '1.2rem',
                            fontWeight: '700',
                            color: '#1daeb2',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                          }}
                        >
                          <i className="fa fa-cube me-2"></i>Item Name
                        </p>
                        <p
                          className="mb-0 fw-bold"
                          style={{ fontSize: '1.25rem', color: '#004d4d' }}
                        >
                          {jobDetails.single_item_title}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Job Specifications Section (Directly showing details cards) */}
          {getDetails()}



          {/* Documents Section */}
          {(jobDetails?.paar_link || jobDetails?.performa_invoice || jobDetails?.marine_inspection_report) && (
            <div
              className="card border-0 mt-4 mb-2"
              style={{
                borderRadius: '16px',
                boxShadow: '0 8px 24px rgba(0,118,121,0.12)',
                overflow: 'hidden',
                background: '#ffffff',
              }}
            >
              <div
                className="card-header"
                style={{
                  background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                  borderBottom: '3px solid #1daeb2',
                  padding: '1.5rem 2rem',
                }}
              >
                <h4
                  className="mb-0"
                  style={{ color: '#ffffff', fontSize: '1.4rem', fontWeight: '700' }}
                >
                  <i
                    className="fa fa-file-text"
                    style={{ marginRight: '8px', color: '#ffffff' }}
                  ></i>
                  Documents
                </h4>
              </div>
              <div className="card-body p-4" style={{ background: '#fafafa' }}>
                <div className="row g-4 justify-content-center">
                  {jobDetails.paar_link && (
                    <div className="col-lg-3 col-md-6 col-sm-6">
                      <div
                        className="text-center p-4 rounded-4 h-100"
                        style={{
                          background: '#f8f9fa',
                          border: '2px solid #e0e0e0',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                        }}
                        onClick={() => showDoc(jobDetails.paar_link)}
                      >
                        <i
                          className="fa fa-file-pdf-o mb-3 d-block"
                          style={{ fontSize: '3rem', color: '#007679' }}
                        ></i>
                        <p
                          className="mb-0 fw-bold"
                          style={{ fontSize: '1rem', color: '#2c3e50' }}
                        >
                          PAAR Document
                        </p>
                      </div>
                    </div>
                  )}
                  {/* The Bill of Lading is deliberately NOT shown here.
                      This modal is what an agent opens while deciding whether
                      to bid, and it was previously handing the document to
                      every agent browsing the pool — including ones who went on
                      to lose the job.

                      The agent who wins gets it on their own job screen, where
                      the API supplies it through privateJobDocs after checking
                      they are the assigned agent. Terminal and Shipping Line
                      are shown above and carry what a bidder needs to price
                      the work. */}
                  {jobDetails.performa_invoice && (
                    <div className="col-lg-3 col-md-6 col-sm-6">
                      <div
                        className="text-center p-4 rounded-4 h-100"
                        style={{
                          background: '#f8f9fa',
                          border: '2px solid #e0e0e0',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                        }}
                        onClick={() => showDoc(jobDetails.performa_invoice)}
                      >
                        <i
                          className="fa fa-file-pdf-o mb-3 d-block"
                          style={{ fontSize: '3rem', color: '#1daeb2' }}
                        ></i>
                        <p
                          className="mb-0 fw-bold"
                          style={{ fontSize: '1rem', color: '#2c3e50' }}
                        >
                          Proforma Invoice
                        </p>
                      </div>
                    </div>
                  )}
                  {jobDetails.marine_inspection_report && (
                    <div className="col-lg-3 col-md-6 col-sm-6">
                      <div
                        className="text-center p-4 rounded-4 h-100"
                        style={{
                          background: '#f8f9fa',
                          border: '2px solid #e0e0e0',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                        }}
                        onClick={() => showDoc(jobDetails.marine_inspection_report)}
                      >
                        <i
                          className="fa fa-file-pdf-o mb-3 d-block"
                          style={{ fontSize: '3rem', color: '#004d4d' }}
                        ></i>
                        <p
                          className="mb-0 fw-bold"
                          style={{ fontSize: '1rem', color: '#2c3e50' }}
                        >
                          Marine Report
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default JobDetailsModal;
